import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrderingPrimary = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.33333 15V13.75H11.6667V15H8.33333ZM5 10.625V9.375H15V10.625H5ZM2.5 6.25V5H17.5V6.25H2.5Z",
		fill: "#118AB2"
	})
});
export default SvgOrderingPrimary;
